//创建和初始化地图函数：
export function initMap(){
  createMap();//创建地图
  setMapEvent();//设置地图事件
  addMapControl();//向地图添加控件
  addMapOverlay();//向地图添加覆盖物
  // map.setMapStyle({style:"dark"});
  map.setMapStyleV2({
    styleId: 'cebddd115f78e3f59d6b8ad5f26321f2'
  });
}
function createMap(){
  map = new window.BMap.Map("map");
  map.centerAndZoom(new window.BMap.Point(121.6442491851,29.8801135277),12);
}
function setMapEvent(){
  //map.enableScrollWheelZoom();
  map.enableKeyboard();
  map.enableDragging();
  map.enableDoubleClickZoom()
}
function addClickHandler(target,window){
  target.addEventListener("click",function(){
    target.openInfoWindow(window);
  });
}
function addMapOverlay(){
  var markers = [
    {content:"中国 · 浙江 · 宁波高新区菁华路58号",title:"宁波君安控股有限公司",imageOffset: {width:-46,height:-21},position:{lat:29.8801135277,lng:121.6442491851}}
  ];
  for(var index = 0; index < markers.length; index++ ){
    var point = new window.BMap.Point(markers[index].position.lng,markers[index].position.lat);
    var marker = new window.BMap.Marker(point);
    marker.addEventListener('click',function(){
      window.open("https://map.baidu.com/search/%E5%90%9B%E5%AE%89%E5%A4%A7%E5%8E%A6/@13541421.094121104,3466608.969255,19z?querytype=s&da_src=shareurl&wd=%E5%90%9B%E5%AE%89%E5%A4%A7%E5%8E%A6&c=180&src=0&wd2=%E5%AE%81%E6%B3%A2%E5%B8%82%E9%84%9E%E5%B7%9E%E5%8C%BA&pn=0&sug=1&l=13&b=(13511855,3455174;13573295,3486182)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&sug_forward=ba5afdab10b9487c7ec87666&device_ratio=1","_blank");
      // window.location.href='http://junankg.com/admin/main.php';
    });
    var label = new window.BMap.Label(markers[index].title,{offset: new window.BMap.Size(25,5)});
    var opts = {
      width: 200,
      title: markers[index].title,
      enableMessage: false
    };
    var infoWindow = new window.BMap.InfoWindow(markers[index].content,opts);
    marker.setLabel(label);
    addClickHandler(marker,infoWindow);
    map.addOverlay(marker);
  };
}
//向地图添加控件
function addMapControl(){
  var navControl = new window.BMap.NavigationControl({anchor:BMAP_ANCHOR_TOP_LEFT,type:3});
  map.addControl(navControl);
}
var map;
